module.exports = __webpack_public_path__ + "img/Playbutton.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Playbutton.svg
// module id = 253
// module chunks = 0